import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { usePet } from '../contexts/PetContext';
import axios from 'axios';
import { 
  Heart, Star, Clock, CheckCircle2, Plus, LogOut, 
  Sparkles, Utensils, Gamepad2, Trophy, Target, Timer,
  CalendarClock, BookOpen, BarChart3, ShoppingBag, GalleryHorizontalEnd,
  Sun, Moon, Monitor, Volume2, VolumeX, StickyNote, ScrollText, Sparkles as SparklesIcon, Lock, Shirt, Sprout, BookOpenText, Home as HomeIcon, Film as FilmIcon, Dumbbell, Wand2, Zap, Mic, AlertOctagon, Menu, X
} from 'lucide-react';
import TaskList from '../components/TaskList';
import FocusTimer from '../components/FocusTimer';
import SchedulePage from '../components/SchedulePage';
import LockScreen from '../components/LockScreen';
import BujoPage from '../components/BujoPage';
import WeeklyStats from '../components/WeeklyStats';
import CategoryMixCard from '../components/CategoryMixCard';
import BuddySettingsCard from '../components/BuddySettingsCard';
import AccessoryShop from '../components/AccessoryShop';
import PetGallery from '../components/PetGallery';
import StreakBanner from '../components/StreakBanner';
import AchievementBadges from '../components/AchievementBadges';
import ShareCard from '../components/ShareCard';
import KeepNotes from '../components/KeepNotes';

import DailyPlanner from '../components/DailyPlanner';
import WeatherWidget from '../components/WeatherWidget';
import LearnHub from '../components/LearnHub';
import FastingClock from '../components/FastingClock';
import ChallengesHub from '../components/ChallengesHub';
import ZinniaSpread from '../components/ZinniaSpread';
import Pyssel from '../components/Pyssel';
import PhotoAlarm from '../components/PhotoAlarm';
import MinPlanner from '../components/MinPlanner';
import PetDialog from '../components/PetDialog';
import PetCelebration from '../components/PetCelebration';
import OutfitPresets from '../components/OutfitPresets';
import BucketList from '../components/BucketList';
import MemoryTrophies from '../components/MemoryTrophies';
import SecretNotes from '../components/SecretNotes';
import StickyRow from '../components/StickyRow';
import StyleTips from '../components/StyleTips';
import SmartSchedule from '../components/SmartSchedule';
import CleaningPage from '../components/CleaningPage';
import WritingRulesPage from '../components/WritingRulesPage';
import CalendarPage from '../components/CalendarPage';
import UpcomingEventsCard from '../components/UpcomingEventsCard';
import PetCoach from '../components/PetCoach';
import JustTodayMode from '../components/JustTodayMode';
import ReadingLog from '../components/ReadingLog';
import RoomAnalyzer from '../components/RoomAnalyzer';
import Redesign from '../components/Redesign';
import Skincare from '../components/Skincare';
import BodyHub from '../components/BodyHub';
import MorningBrief from '../components/MorningBrief';
import KalenderCentral from '../components/KalenderCentral';
import Goals from '../components/Goals';
import Trolla from '../components/Trolla';
import ResetLab from '../components/ResetLab';
import FarmorCorgi from '../components/FarmorCorgi';
import ExportDataButton from '../components/ExportDataButton';
import LlmBudgetBanner from '../components/LlmBudgetBanner';
import UserAvatar from '../components/UserAvatar';
import StockHub from '../components/StockHub';
import HabitTracker from '../components/HabitTracker';
import RoomRotation from '../components/RoomRotation';
import MessKickstart from '../components/MessKickstart';
import MicroWinsCounter from '../components/MicroWinsCounter';
import MinSida from '../components/MinSida';
import RunCoach from '../components/RunCoach';
import DailyFlow from '../components/DailyFlow';
import SundayRecap from '../components/SundayRecap';
import FamilyPlay from '../components/FamilyPlay';
import BodyPage from '../components/BodyPage';
import TodayWorkoutCard from '../components/TodayWorkoutCard';
import AdventureScene from '../components/AdventureScene';
import SocialTab from '../components/SocialTab';
import HypnosTab from '../components/HypnosTab';
import InfluenceTab from '../components/InfluenceTab';
import UpcomingMeetingBanner from '../components/UpcomingMeetingBanner';
import RecentMeetingFollowup from '../components/RecentMeetingFollowup';
import RoomHappinessCard from '../components/RoomHappinessCard';
import GlobalHelp from '../components/GlobalHelp';
import EmptyDayBubble from '../components/EmptyDayBubble';
import PrivateVideos from '../components/PrivateVideos';
import Diary from '../components/Diary';
import MakeupStudio from '../components/MakeupStudio';
import WardrobePage from '../components/WardrobePage';
import TimeTravelPage from '../components/TimeTravelPage';
import TimeFeedPage from '../components/TimeFeedPage';
import CalendarHubPage from '../components/CalendarHubPage';
import AppleCalendarSync from '../components/AppleCalendarSync';
import LostItemsTab from '../components/LostItemsTab';
import MeetingDaySuggestionCard from '../components/MeetingDaySuggestionCard';
import WakeUpSOSModal from '../components/WakeUpSOSModal';
import WakeUpInsightCard from '../components/WakeUpInsightCard';
import WakeUpWeeklyReportCard from '../components/WakeUpWeeklyReportCard';
import NarratorPanel from '../components/NarratorPanel';
import QuickImpulseModal from '../components/QuickImpulseModal';
import KonMariTab from '../components/KonMariTab';
import MinnestraningTab from '../components/MinnestraningTab';
import VitMagiTab from '../components/VitMagiTab';
import InspirationTab from '../components/InspirationTab';
import ThemeSwitcher from '../components/ThemeSwitcher';
import StudioTab from '../components/StudioTab';
import ProjectsTab from '../components/ProjectsTab';
import ImportantReminders from '../components/ImportantReminders';
import EpisodeSupport from '../components/EpisodeSupport';
import RoutineNotifications from '../components/RoutineNotifications';
import TidsblockReminder from '../components/TidsblockReminder';
import GlobalDictatePanel from '../components/GlobalDictatePanel';
import ReaderPage from '../components/ReaderPage';
import VoiceRecorderTab from '../components/VoiceRecorderTab';
import ShoppingTab from '../components/ShoppingTab';
import DreamsTab from '../components/DreamsTab';
import CalmFloatingButton from '../components/CalmFloatingButton';
import HampusNudge from '../components/HampusReminder';
import DagbladFrontPage, { DagbladGate } from '../components/DagbladFrontPage';
import DayDoneCelebration from '../components/DayDoneCelebration';
import PaintByNumbersPage from '../components/PaintByNumbersPage';
import ImorgonBriefing from '../components/ImorgonBriefing';
import ParkeraRestenModal from '../components/ParkeraRestenModal';
import CleaningTriageModal from '../components/CleaningTriageModal';
import NarratorCheatSheet from '../components/NarratorCheatSheet';
import PhraseEditor from '../components/PhraseEditor';
import GlobalPhraseExpander from '../components/GlobalPhraseExpander';
import EkonomiPage from '../components/EkonomiPage';
import PuzzlesPage from '../components/PuzzlesPage';
import PuzzleAlarmsManager from '../components/PuzzleAlarmsManager';
import PTPage from '../components/PTPage';
import PTGoalWorkout from '../components/PTGoalWorkout';
import ExpertsHub from '../components/ExpertsHub';
import MorningPrompt from '../components/MorningPrompt';
import FiaReleaseNudge from '../components/FiaReleaseNudge';
import TamagotchiCareWidget from '../components/TamagotchiCareWidget';
import WalkJourney from '../components/WalkJourney';
import ScheduleLockOverlay from '../components/ScheduleLockOverlay';
import VoicePresetPicker from '../components/VoicePresetPicker';import { FloatingDoodles, DoodleBorder } from '../components/Doodles';
import { PetAvatar, EvolveButton, EvolutionCeremony, StageIndicator } from '../components/PetEvolution';
import { useTheme } from '../contexts/ThemeContext';
import { isSoundEnabled, setSoundEnabled } from '../utils/sounds';
import GroupedTabs from '../components/DashboardTabs';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function DashboardPage() {
  const { user, logout, refreshUser } = useAuth();
  const { pet, feedPet, playWithPet, refreshPet, hasPet } = usePet();
  const { theme, setTheme } = useTheme();
  const navigate = useNavigate();
  const [stats, setStats] = useState(null);
  const [activeTab, setActiveTab] = useState('mysida');
  const [activeGroup, setActiveGroup] = useState('plan');
  // Cross-component navigation: any child can dispatch a 'focus-critter:navigate' CustomEvent
  useEffect(() => {
    const handler = (e) => {
      const tab = e?.detail?.tab;
      if (!tab) return;
      setActiveTab(tab);
      // scroll to top so the user immediately sees the target module
      try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch {}
    };
    window.addEventListener('focus-critter:navigate', handler);
    return () => window.removeEventListener('focus-critter:navigate', handler);
  }, []);
  const [episodeOpen, setEpisodeOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  useEffect(() => {
    if (!menuOpen) return undefined;
    const onDown = (e) => { if (!e.target.closest('[data-testid="header-actions"]')) setMenuOpen(false); };
    document.addEventListener('pointerdown', onDown);
    return () => document.removeEventListener('pointerdown', onDown);
  }, [menuOpen]);
  const [wakeupOpen, setWakeupOpen] = useState(false);
  const [narratorOpen, setNarratorOpen] = useState(false);
  const [impulseOpen, setImpulseOpen] = useState(false);
  const [imorgonOpen, setImorgonOpen] = useState(false);
  const [parkeraOpen, setParkeraOpen] = useState(false);
  const [triageOpen, setTriageOpen] = useState(false);
  const [phraseEditorOpen, setPhraseEditorOpen] = useState(false);
  const [justToday, setJustToday] = useState(false);
  const [lockStatus, setLockStatus] = useState({ is_locked: false, blocking_item: null });
  const [evolutionResult, setEvolutionResult] = useState(null);
  const [soundOn, setSoundOn] = useState(isSoundEnabled());
  const [weatherCondition, setWeatherCondition] = useState(null);
  const [currentWeather, setCurrentWeather] = useState(null);
  const [celebrationTick, setCelebrationTick] = useState(0);
  const [celebrationKind, setCelebrationKind] = useState('task');

  const toggleSound = () => {
    const next = !soundOn;
    setSoundOn(next);
    setSoundEnabled(next);
  };

  // Auto-show "Imorgon-briefing" in the evening (once per day, if delivery includes popup)
  useEffect(() => {
    let cancelled = false;
    const check = async () => {
      try {
        const r = await axios.get(`${API}/imorgon/briefing/should-show`, { withCredentials: true });
        if (!cancelled && r.data?.should_show && !imorgonOpen) {
          setImorgonOpen(true);
        }
      } catch { /* poll error — ignore */ }
    };
    check();
    const t = setInterval(check, 5 * 60 * 1000); // poll every 5 min
    return () => { cancelled = true; clearInterval(t); };
  }, []);

  // Listen for keyboard shortcut event from GlobalNarrator
  useEffect(() => {
    const open = () => setNarratorOpen(true);
    window.addEventListener('open-narrator-panel', open);
    return () => window.removeEventListener('open-narrator-panel', open);
  }, []);

  const cycleTheme = () => {
    const order = ['light', 'dark', 'system'];
    const idx = order.indexOf(theme);
    setTheme(order[(idx + 1) % order.length]);
  };

  const themeIcon = theme === 'dark' ? Moon : theme === 'light' ? Sun : Monitor;

  const fetchStats = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/stats`, { withCredentials: true });
      setStats(data);
    } catch (e) {
      console.error('Failed to fetch stats:', e);
    }
  }, []);

  const checkLockStatus = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/schedule/lock-status`, { withCredentials: true });
      setLockStatus(data);
    } catch (e) {
      // If error, don't lock
      setLockStatus({ is_locked: false, blocking_item: null });
    }
  }, []);

  useEffect(() => {
    if (!hasPet) {
      navigate('/choose-pet');
      return;
    }
    fetchStats();
    checkLockStatus();

    // Check lock status every 30 seconds
    const lockInterval = setInterval(checkLockStatus, 30000);
    return () => clearInterval(lockInterval);
  }, [hasPet, navigate, fetchStats, checkLockStatus]);

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const handleFeed = async () => {
    await feedPet();
    await fetchStats();
    if (soundOn) {
      import('../utils/voicePresets').then(({ VOICE_PRESETS, speakWithPreset }) => {
        const preset = VOICE_PRESETS[localStorage.getItem('focus_critter_voice_preset') || 'cat'] || VOICE_PRESETS.cat;
        const phrases = ['Mums, tack för maten!', 'Jaaa, det var gott!', 'Näms näms! Mer tack!', 'Åh vad gott!', 'Jag älskar dig!'];
        speakWithPreset(phrases[Math.floor(Math.random() * phrases.length)], preset);
      });
    }
  };

  const handlePlay = async () => {
    await playWithPet();
    await fetchStats();
    if (soundOn) {
      import('../utils/voicePresets').then(({ VOICE_PRESETS, speakWithPreset }) => {
        const preset = VOICE_PRESETS[localStorage.getItem('focus_critter_voice_preset') || 'cat'] || VOICE_PRESETS.cat;
        const phrases = ['Jippi! Lek med mig!', 'Hihi, kittlar!', 'Yay! Mer mer!', 'Så roligt!', 'Bästa kompis!'];
        speakWithPreset(phrases[Math.floor(Math.random() * phrases.length)], preset);
      });
    }
  };

  const onTaskComplete = async () => {
    setCelebrationKind('task');
    setCelebrationTick((t) => t + 1);
    await refreshPet();
    await fetchStats();
    if (soundOn) {
      import('../utils/voicePresets').then(({ VOICE_PRESETS, speakWithPreset }) => {
        const preset = VOICE_PRESETS[localStorage.getItem('focus_critter_voice_preset') || 'cat'] || VOICE_PRESETS.cat;
        const phrases = ['Duktig!', 'Så bra!', 'Wow, du gjorde det!', 'Stolt över dig!', 'Jätteduktig!'];
        speakWithPreset(phrases[Math.floor(Math.random() * phrases.length)], preset);
      });
    }
  };

  const onSessionComplete = async () => {
    setCelebrationKind('focus');
    setCelebrationTick((t) => t + 1);
    await refreshPet();
    await fetchStats();
    if (soundOn) {
      import('../utils/voicePresets').then(({ VOICE_PRESETS, speakWithPreset }) => {
        const preset = VOICE_PRESETS[localStorage.getItem('focus_critter_voice_preset') || 'cat'] || VOICE_PRESETS.cat;
        const phrases = ['Fantastiskt fokus!', 'Tid för paus!', 'Bra jobbat med fokuset!', 'Hjärnan blir starkare!'];
        speakWithPreset(phrases[Math.floor(Math.random() * phrases.length)], preset);
      });
    }
  };

  const handleUnlock = async () => {
    setLockStatus({ is_locked: false, blocking_item: null });
    await refreshPet();
    await fetchStats();
    await refreshUser();
    setTimeout(checkLockStatus, 500);
  };

  const handleEvolve = async () => {
    try {
      const { data } = await axios.post(`${API}/pets/evolve`, {}, { withCredentials: true });
      setEvolutionResult(data);
    } catch (e) {
      console.error('Failed to evolve:', e);
    }
  };

  const handleCloseEvolution = async () => {
    setEvolutionResult(null);
    await refreshPet();
    await fetchStats();
  };

  if (!hasPet || !pet) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-transparent">
        <div className="text-center">
          <div className="w-16 h-16 mx-auto mb-4 rounded-full border-4 border-black bg-[#A2D2FF] animate-pulse-soft" />
          <p className="text-lg font-semibold text-gray-700">Loading your companion...</p>
        </div>
      </div>
    );
  }

  // Show lock screen if app is locked
  if (lockStatus.is_locked && lockStatus.blocking_item) {
    return (
      <LockScreen
        blockingItem={lockStatus.blocking_item}
        pet={pet}
        onUnlock={handleUnlock}
      />
    );
  }

  return (
    <div className="min-h-screen bg-transparent dark:bg-[#1a1a2e] pb-8" data-testid="dashboard-page">
      <RoutineNotifications />
      <TidsblockReminder />
      <GlobalDictatePanel />
      {/* Header */}
      <header className="bg-white dark:bg-[#252545] border-b-[3px] border-black dark:border-[#444] shadow-[0_4px_0px_0px_rgba(0,0,0,1)] dark:shadow-[0_4px_0px_0px_rgba(100,100,150,0.4)] sticky top-0 z-50">
        <div className="max-w-6xl mx-auto px-3 sm:px-4 py-2 sm:py-3 flex items-center justify-between gap-2">
          <div className="flex items-center gap-3 flex-shrink-0">
            <div className="w-10 h-10 rounded-full bg-[#FFC8DD] border-2 border-black flex items-center justify-center">
              <Heart className="w-5 h-5" strokeWidth={2.5} />
            </div>
            <h1 className="hidden sm:block text-xl md:text-2xl font-bold font-['Fredoka']">Focus Critter</h1>
          </div>
          
          <div className="relative flex flex-wrap items-center justify-end gap-1.5 sm:gap-2 min-w-0" data-testid="header-actions">
            <div
              className={`absolute right-0 top-full z-[96] ${menuOpen
                ? 'mt-2 flex flex-wrap gap-2 p-3 w-[calc(100vw-1.5rem)] max-w-sm bg-white dark:bg-[#252545] border-[3px] border-black rounded-2xl shadow-[4px_4px_0_0_rgba(0,0,0,1)]'
                : 'h-0 w-0 overflow-hidden invisible'}`}
              onClick={(e) => { if (e.target.closest('[data-testid$="-open-btn"],[data-testid="phrase-editor-btn"],[data-testid="logout-btn"]')) setMenuOpen(false); }}
              data-testid="header-menu-panel"
            >
            {/* Theme toggle */}
            <button
              onClick={cycleTheme}
              className="neo-btn p-2 bg-white dark:bg-gray-800"
              data-testid="theme-toggle"
              title={`Theme: ${theme}`}
            >
              {React.createElement(themeIcon, { className: "w-4 h-4" })}
            </button>
            {/* Sound toggle */}
            <button
              onClick={toggleSound}
              className="neo-btn p-2 bg-white dark:bg-gray-800"
              data-testid="sound-toggle"
              title={soundOn ? 'Sound on' : 'Sound off'}
            >
              {soundOn ? <Volume2 className="w-4 h-4" /> : <VolumeX className="w-4 h-4" />}
            </button>
            {/* Voice preset picker — kawaii animal voices */}
            <VoicePresetPicker compact />
            {/* Global help — searchable feature finder */}
            <GlobalHelp onOpenTab={(t) => {
              const legacy = { today: 'calendar', tasks: 'calendar', schedule: 'calendar', bujo: 'calendar', cleaning: 'calendar' };
              setActiveTab(legacy[t] || t);
            }} />
            {/* Vakna upp-SOS — emergency wakefulness rescue */}
            <button
              onClick={() => setWakeupOpen(true)}
              className="neo-btn px-2 py-1.5 bg-gradient-to-br from-[#FFE8A3] to-[#FFC8DD] flex items-center gap-1 text-xs font-bold animate-pulse-slow"
              title="Vakna upp — när dimman kommer"
              data-testid="wakeup-open-btn"
            >
              <Zap className="w-4 h-4 text-yellow-700" fill="currentColor" />
              <span>Vakna upp</span>
            </button>
            {/* Berättare — live text-to-speech for work */}
            <button
              onClick={() => setNarratorOpen(true)}
              className="neo-btn px-2 py-1.5 bg-gradient-to-br from-[#A2D2FF] to-[#E8F4FF] flex items-center gap-1 text-xs font-bold"
              title="Berättare — läs upp medan du skriver"
              data-testid="narrator-open-btn"
            >
              <Mic className="w-4 h-4 text-[#4A8BC7]" />
              <span>Berättare</span>
            </button>
            {/* "Bara snabbt"-akut — interrupt ADHD impulse */}
            <button
              onClick={() => setImpulseOpen(true)}
              className="neo-btn px-2 py-1.5 bg-gradient-to-br from-[#FFAAA5] to-[#FFD3B6] flex items-center gap-1 text-xs font-bold"
              title="'Bara snabbt'-akut — stoppa ADHD-impulsen"
              data-testid="impulse-open-btn"
            >
              <AlertOctagon className="w-4 h-4 text-red-700" />
              <span>Bara snabbt</span>
            </button>
            {/* Imorgon-briefing — kvälls-checklista per barn */}
            <button
              onClick={() => setImorgonOpen(true)}
              className="neo-btn px-2 py-1.5 bg-gradient-to-br from-[#C8B6FF] to-[#E8DCFF] flex items-center gap-1 text-xs font-bold"
              title="Imorgon — kvälls-briefing per barn"
              data-testid="imorgon-open-btn"
            >
              <span className="text-base leading-none">🌙</span>
              <span>Imorgon</span>
            </button>
            {/* Parkera resten — focus mode that holds everything else */}
            <button
              onClick={() => setParkeraOpen(true)}
              className="neo-btn px-2 py-1.5 bg-gradient-to-br from-[#B9FBC0] to-[#A7E8DB] flex items-center gap-1 text-xs font-bold"
              title="Parkera resten — fokus utan att tappa allt annat"
              data-testid="parkera-open-btn"
            >
              <span className="text-base leading-none">🌳</span>
              <span>Parkera resten</span>
            </button>
            {/* Snabb-städ-triage — vilka tasks ryms i tiden? */}
            <button
              onClick={() => setTriageOpen(true)}
              className="neo-btn px-2 py-1.5 bg-gradient-to-br from-[#E0F4E1] to-[#C8E6C9] flex items-center gap-1 text-xs font-bold"
              title="Snabb-städ — vilka tasks ryms i tiden? Eller planera för besök"
              data-testid="triage-open-btn"
            >
              <span className="text-base leading-none">🧹</span>
              <span>Snabb-städ</span>
            </button>
            {/* Fraseditor — text expander snippets */}
            <button
              onClick={() => setPhraseEditorOpen(true)}
              className="neo-btn px-2 py-1.5 bg-gradient-to-br from-[#E0D5FF] to-[#CDBFFF] flex items-center gap-1 text-xs font-bold"
              title="Fraseditor — skriv ;trigger för att infoga hel mening"
              data-testid="phrase-editor-btn"
            >
              <span className="text-base leading-none">✨</span>
              <span>Fraser</span>
            </button>
            <PuzzleAlarmsManager />
            <ExportDataButton />
            <button
              onClick={handleLogout}
              className="neo-btn px-3 py-1.5 bg-[#FF6B6B] text-white flex items-center gap-1"
              data-testid="logout-btn"
            >
              <LogOut className="w-4 h-4" />
              <span className="text-sm">Logga ut</span>
            </button>
            </div>
            <MorningPrompt />
            {/* När det kryper — episode support, always 1 click away */}
            <button
              onClick={() => setEpisodeOpen(true)}
              className="neo-btn px-2 py-1.5 bg-gradient-to-br from-[#FFE8F5] to-[#C8B6FF] flex items-center gap-1 text-xs font-bold"
              title="När det kryper — lugnt stöd vid skov"
              data-testid="episode-open-btn"
            >
              <Heart className="w-4 h-4 fill-[#FF8FA3] text-[#FF8FA3]" />
              <span className="hidden sm:inline">När det kryper</span>
              <span className="sm:hidden">SOS</span>
            </button>
            <div className="flex items-center gap-2 bg-[#FDF0D5] px-3 py-1.5 rounded-full border-2 border-black">
              <Star className="w-4 h-4 text-yellow-600" fill="currentColor" />
              <span className="font-bold font-['Fredoka'] text-sm" data-testid="total-points">
                {stats?.total_points || user?.total_points || 0}
              </span>
            </div>
            <UserAvatar />
            <button
              onClick={() => setMenuOpen((v) => !v)}
              className="neo-btn p-2 bg-white dark:bg-gray-800 flex items-center gap-1"
              aria-label={menuOpen ? 'Stäng menyn' : 'Öppna menyn'}
              aria-expanded={menuOpen}
              data-testid="header-menu-btn"
            >
              {menuOpen ? <X className="w-4 h-4" /> : <Menu className="w-4 h-4" />}
              <span className="hidden sm:inline text-xs font-bold">Verktyg</span>
            </button>
          </div>
        </div>
      </header>
      <FiaReleaseNudge setActiveTab={setActiveTab} />

      <LlmBudgetBanner />

      <main className="max-w-6xl mx-auto px-4 py-6">
        {/* Pet & Stats Row */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-6">
          {/* Pet Card */}
          <DoodleBorder color="#FFC8DD">
          <div className="neo-card p-6 lg:col-span-1 relative" data-testid="pet-card">
            <PetCelebration trigger={celebrationTick} kind={celebrationKind} />
            <div className="text-center">
              <PetDialog weather={currentWeather} />
              <div className="mb-3">
                <PetAvatar pet={pet} size="md" weather={weatherCondition} />
              </div>
              
              <h2 className="text-xl font-bold font-['Fredoka'] mb-0.5" data-testid="pet-name">{pet.name}</h2>
              <p className="text-gray-500 text-xs">{pet.stage_title || `Level ${pet.level}`}</p>
              <StageIndicator pet={pet} />
              
              {/* Health */}
              <div className="mb-2">
                <div className="flex justify-between items-center mb-1">
                  <span className="text-xs font-bold flex items-center gap-1">
                    <Heart className="w-3 h-3 text-red-500" fill="currentColor" /> Health
                  </span>
                  <span className="text-xs font-bold">{pet.health}%</span>
                </div>
                <div className="progress-bar" style={{ height: '0.75rem' }}>
                  <div className="progress-fill bg-red-400" style={{ width: `${pet.health}%` }} />
                </div>
              </div>
              
              {/* Happiness */}
              <div className="mb-2">
                <div className="flex justify-between items-center mb-1">
                  <span className="text-xs font-bold flex items-center gap-1">
                    <Star className="w-3 h-3 text-yellow-500" fill="currentColor" /> Happiness
                  </span>
                  <span className="text-xs font-bold">{pet.happiness}%</span>
                </div>
                <div className="progress-bar" style={{ height: '0.75rem' }}>
                  <div className="progress-fill bg-yellow-400" style={{ width: `${pet.happiness}%` }} />
                </div>
              </div>

              {/* XP */}
              <div className="mb-3">
                <div className="flex justify-between items-center mb-1">
                  <span className="text-xs font-bold flex items-center gap-1">
                    <Sparkles className="w-3 h-3 text-purple-500" /> XP
                  </span>
                  <span className="text-xs font-bold">{pet.experience}/{pet.level * 100}</span>
                </div>
                <div className="progress-bar" style={{ height: '0.75rem' }}>
                  <div className="progress-fill bg-purple-400" style={{ width: `${(pet.experience / (pet.level * 100)) * 100}%` }} />
                </div>
              </div>
              
              {/* Pet Actions */}
              <div className="flex gap-2">
                <button onClick={handleFeed} className="neo-btn flex-1 py-2 bg-[#B9FBC0] flex items-center justify-center gap-1 text-sm" data-testid="feed-pet-btn">
                  <Utensils className="w-4 h-4" /><span>Feed</span>
                </button>
                <button onClick={handlePlay} className="neo-btn flex-1 py-2 bg-[#FFC8DD] flex items-center justify-center gap-1 text-sm" data-testid="play-pet-btn">
                  <Gamepad2 className="w-4 h-4" /><span>Play</span>
                </button>
              </div>
              
              {/* Evolve Button */}
              {pet.can_evolve && (
                <div className="mt-3">
                  <EvolveButton pet={pet} onEvolve={handleEvolve} />
                </div>
              )}
            </div>
          </div>
          </DoodleBorder>

          {/* Stats */}
          <div className="lg:col-span-2 grid grid-cols-2 md:grid-cols-4 gap-3">
            <div className="neo-card p-4 text-center bg-[#A2D2FF]">
              <Trophy className="w-7 h-7 mx-auto mb-1" />
              <p className="text-2xl font-bold font-['Fredoka']" data-testid="stats-points">{stats?.total_points || 0}</p>
              <p className="text-xs font-semibold">Points</p>
            </div>
            <div className="neo-card p-4 text-center bg-[#B9FBC0]">
              <CheckCircle2 className="w-7 h-7 mx-auto mb-1" />
              <p className="text-2xl font-bold font-['Fredoka']" data-testid="stats-completed">{stats?.tasks_completed || 0}</p>
              <p className="text-xs font-semibold">Done</p>
            </div>
            <div className="neo-card p-4 text-center bg-[#FFC8DD]">
              <Target className="w-7 h-7 mx-auto mb-1" />
              <p className="text-2xl font-bold font-['Fredoka']" data-testid="stats-pending">{stats?.tasks_pending || 0}</p>
              <p className="text-xs font-semibold">Pending</p>
            </div>
            <div className="neo-card p-4 text-center bg-[#CDB4DB]">
              <Timer className="w-7 h-7 mx-auto mb-1" />
              <p className="text-2xl font-bold font-['Fredoka']" data-testid="stats-focus">{stats?.total_focus_minutes || 0}</p>
              <p className="text-xs font-semibold">Focus Min</p>
            </div>
          </div>
        </div>

        {/* Streak Banner */}
        <StreakBanner />

        {/* Micro-vinst-räknare — unified daily wins */}
        <MicroWinsCounter />

        {/* Quick Post-its */}
        <StickyRow />

        {/* Weather Widget */}
        <div className="mb-4">
          <WeatherWidget
            onPetUpdate={async () => { await refreshPet(); }}
            onWeatherUpdate={(w) => { setWeatherCondition(w?.condition || null); setCurrentWeather(w || null); }}
          />
        </div>

        {/* Upcoming meeting → person card hint */}
        <UpcomingMeetingBanner />

        {/* Recent meeting → grow memory bank */}
        <RecentMeetingFollowup />

        {/* Adventure scene (Stay Wild-style) */}
        <AdventureScene
          onPointsChange={async () => { await refreshUser(); await refreshPet(); await fetchStats(); }}
        />

        {/* Today's Workout Card */}
        <TodayWorkoutCard
          onOpenBody={() => setActiveTab('body')}
          onPointsChange={async () => { await refreshUser(); await refreshPet(); await fetchStats(); }}
        />

        {/* Soft reminder for important upcoming events */}
        <ImportantReminders />
        <ThemeSwitcher />

        {/* Grouped Tab Navigation */}
        <GroupedTabs
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          activeGroup={activeGroup}
          setActiveGroup={setActiveGroup}
          onJustToday={() => setJustToday(true)}
        />

        {/* Content Area */}
        <TamagotchiCareWidget
          pet={pet}
          onUpdate={async () => { await refreshUser(); await refreshPet(); await fetchStats(); }}
        />
        <ScheduleLockOverlay onUpdate={async () => { await refreshUser(); await refreshPet(); }} />
        <WalkJourney onUpdate={async () => { await refreshUser(); await refreshPet(); await fetchStats(); }} />
        <UpcomingEventsCard
          onOpenCalendar={() => setActiveTab('calendar')}
          onPointsChange={async () => { await refreshUser(); await refreshPet(); await fetchStats(); }}
        />
        <MeetingDaySuggestionCard
          onPointsChange={async () => { await refreshUser(); await refreshPet(); await fetchStats(); }}
        />
        <WakeUpInsightCard
          onPointsChange={async () => { await refreshUser(); await refreshPet(); await fetchStats(); }}
        />
        <WakeUpWeeklyReportCard />
        <RoomHappinessCard onOpen={() => setActiveTab('rooms')} />
        {(activeTab === 'calendar' || activeTab === 'today' || activeTab === 'tasks' || activeTab === 'schedule' || activeTab === 'bujo' || activeTab === 'cleaning' || activeTab === 'recap') && (
          <CalendarHubPage />
        )}
        {activeTab === 'apple-cal' && <AppleCalendarSync />}
        {activeTab === 'lost-items' && <LostItemsTab />}
        {activeTab === 'focus' && <FocusTimer pet={pet} onSessionComplete={onSessionComplete} />}
        {activeTab === 'stats' && (
          <div className="space-y-6">
            <WeeklyStats />
            <CategoryMixCard />
            <BuddySettingsCard />
            <AchievementBadges />
            <MemoryTrophies />
            <ShareCard />
          </div>
        )}
        {activeTab === 'shop' && (
          <div className="space-y-6">
            <AccessoryShop onUpdate={async () => { await refreshPet(); await fetchStats(); }} />
            <OutfitPresets onApplied={async () => { await refreshPet(); }} />
          </div>
        )}
        {activeTab === 'gallery' && <PetGallery onSwitch={async () => { await refreshPet(); await fetchStats(); }} />}
        {activeTab === 'notes' && <KeepNotes />}
        {activeTab === 'reader' && <ReaderPage />}
        {activeTab === 'voice' && <VoiceRecorderTab />}
        {activeTab === 'shopping' && <ShoppingTab />}
        {activeTab === 'projects' && <ProjectsTab />}
        {activeTab === 'dreams' && <DreamsTab />}
        {activeTab === 'history' && (
          <LearnHub onUpdate={async () => { await refreshUser(); await fetchStats(); }} />
        )}
        {activeTab === 'fasting' && <FastingClock />}
        {activeTab === 'challenges' && <ChallengesHub />}
        {activeTab === 'zinnia' && <ZinniaSpread />}
        {activeTab === 'pyssel' && <Pyssel />}
        {activeTab === 'photo-alarm' && <PhotoAlarm />}
        {activeTab === 'planner' && <MinPlanner />}
        {activeTab === 'bucket' && (
          <BucketList onUpdate={async () => { await refreshUser(); await fetchStats(); }} />
        )}
        {activeTab === 'secret' && <SecretNotes />}
        {activeTab === 'style' && <StyleTips />}
        {activeTab === 'writing' && <WritingRulesPage />}
        {activeTab === 'reading' && (
          <ReadingLog onPointsChange={async () => { await refreshUser(); await refreshPet(); await fetchStats(); }} />
        )}
        {activeTab === 'rooms' && <RoomAnalyzer onPointsChange={async () => { await refreshUser(); await refreshPet(); await fetchStats(); }} />}
        {activeTab === 'redesign' && <Redesign />}
        {activeTab === 'skincare' && <Skincare />}
        {activeTab === 'body-hub' && <BodyHub />}
        {activeTab === 'morning-brief' && <MorningBrief />}
        {activeTab === 'dagblad' && <DagbladFrontPage />}
        {activeTab === 'kalender-central' && <KalenderCentral />}
        {activeTab === 'goals' && <Goals />}
        {activeTab === 'trolla' && <Trolla />}
        {activeTab === 'reset-lab' && <ResetLab />}
        {activeTab === 'farmor-corgi' && <FarmorCorgi />}
        {activeTab === 'daily-flow' && <DailyFlow />}
        {activeTab === 'sunday' && <SundayRecap />}
        {activeTab === 'family-play' && <FamilyPlay />}
        {activeTab === 'konmari' && <KonMariTab />}
        {activeTab === 'minnes' && <MinnestraningTab />}
        {activeTab === 'vitmagi' && <VitMagiTab />}
        {activeTab === 'inspiration' && <InspirationTab />}
        {activeTab === 'studio' && <StudioTab />}
        {activeTab === 'body' && <BodyPage onPointsChange={async () => { await refreshUser(); await refreshPet(); await fetchStats(); }} />}
        {activeTab === 'social' && <SocialTab />}
        {activeTab === 'influence' && <InfluenceTab />}
        {activeTab === 'hypnos' && <HypnosTab />}
        {activeTab === 'memories' && <PrivateVideos />}
        {activeTab === 'diary' && <Diary />}
        {activeTab === 'makeup' && <MakeupStudio />}
        {activeTab === 'wardrobe' && <WardrobePage />}
        {activeTab === 'timetravel' && <TimeFeedPage />}
        {activeTab === 'timewalk' && <TimeTravelPage />}
        {activeTab === 'paint' && <PaintByNumbersPage />}
        {activeTab === 'puzzles' && <PuzzlesPage />}
        {activeTab === 'pt' && <PTPage />}
        {activeTab === 'pt-goal' && <PTGoalWorkout />}
        {activeTab === 'experts' && <ExpertsHub />}
        {activeTab === 'envelopes' && <EkonomiPage />}
        {activeTab === 'stocks' && <StockHub />}
        {activeTab === 'habits' && <HabitTracker />}
        {activeTab === 'room-rotation' && <RoomRotation />}
        {activeTab === 'kickstart' && <MessKickstart />}
        {activeTab === 'mysida' && <MinSida />}
        {activeTab === 'run-coach' && <RunCoach />}
      </main>
      <EpisodeSupport open={episodeOpen} onClose={() => setEpisodeOpen(false)} />
      <WakeUpSOSModal open={wakeupOpen} onClose={() => setWakeupOpen(false)} />
      <NarratorPanel open={narratorOpen} onClose={() => setNarratorOpen(false)} />
      <QuickImpulseModal open={impulseOpen} onClose={() => setImpulseOpen(false)} />
      <ImorgonBriefing open={imorgonOpen} onClose={() => setImorgonOpen(false)} />
      <ParkeraRestenModal open={parkeraOpen} onClose={() => setParkeraOpen(false)} />
      <CleaningTriageModal
        open={triageOpen}
        onClose={() => setTriageOpen(false)}
        onJumpToRooms={() => setActiveTab('rooms')}
      />
      <NarratorCheatSheet />
      <PhraseEditor open={phraseEditorOpen} onClose={() => setPhraseEditorOpen(false)} />
      <GlobalPhraseExpander />
      <FloatingDoodles />
      <PetCoach pet={pet} />
      {justToday && (
        <JustTodayMode
          onExit={() => setJustToday(false)}
          onPointsChange={async () => { await refreshUser(); await refreshPet(); await fetchStats(); }}
        />
      )}
      {/* Evolution Ceremony Overlay */}
      {evolutionResult && (
        <EvolutionCeremony pet={pet} evolutionResult={evolutionResult} onClose={handleCloseEvolution} />
      )}
      <EmptyDayBubble pet={pet} />
      <CalmFloatingButton />
      <HampusNudge />
      <DagbladGate />
      <DayDoneCelebration />
    </div>
  );
}
